import React, {
  PropsWithChildren,
  ReactNode,
} from 'react';
import clsx from 'clsx';
import Skeleton from 'core/components/Skeleton';
import {
  formatMoney,
} from '@populateui/utils';

type Part = 'title' | 'value' | 'root';

type Props = PropsWithChildren & {
  value?: number;
  title: string | ReactNode;
  classes?: Partial<Record<Part, string>>;
  isLoading?: boolean;
};

export default function SummaryItem({
  value = 0,
  title,
  classes,
  children,
  isLoading,
}: Props) {
  return (
    <div className={clsx('flex flex-col gap-1 w-1/2', classes?.root)}>
      <div className={clsx('font-semibold text-gray-400 text-sm', classes?.title)}>
        {title}
      </div>
      <div className={clsx('font-semibold text-gray-900 text-xl', classes?.value)}>
        {isLoading ? <Skeleton className="h-6 w-20" /> : formatMoney(value)}
      </div>
      {children}
    </div>
  );
}
